import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-sans font-bold break-normal text-gray-700 px-2 pb-2" }, " スタッフ追加 ", -1)
const _hoisted_2 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "mb-2 last:mb-0" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("名前"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_8 = { class: "text-xs text-pink-600" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, " ", -1)
const _hoisted_11 = { class: "text-xs text-pink-600" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mt-2" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("名前(カナ)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_15 = { class: "text-xs text-pink-600" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, " ", -1)
const _hoisted_18 = { class: "text-xs text-pink-600" }
const _hoisted_19 = {
  key: 0,
  class: "mb-2 last:mb-0"
}
const _hoisted_20 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_23 = { class: "text-xs text-pink-600" }
const _hoisted_24 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_25 = { class: "p-6" }
const _hoisted_26 = { class: "mb-2 last:mb-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("店舗"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_28 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-xs text-pink-600" }
const _hoisted_32 = { class: "text-right col-span-full mt-4" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "flex p-4 mt-4 mb-4 bg-red-100 rounded-lg dark:bg-red-200",
  role: "alert"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 w-5 h-5 text-red-700 dark:text-red-800",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_36 = { class: "ml-3 text-sm font-medium text-red-700 dark:text-red-800" }

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

import Staff from "@/models/Staff";
import Shop from "@/models/Shop";
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const formSchema = yup.object({
  family_name: yup.string().required("必須項目です"),
  given_name: yup.string().required("必須項目です"),
  family_name_kana: yup.string().kana().required("必須項目です"),
  given_name_kana: yup.string().kana().required("必須項目です"),
  email: yup.string().email().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const family_name_field = useField<string>("family_name");
const given_name_field = useField<string>("given_name");
const family_name_kana_field = useField<string>("family_name_kana");
const given_name_kana_field = useField<string>("given_name_kana");
const email_field = useField<string>("email");

const showing_suggest = ref<boolean>(false);

const staff = ref<Staff | null>(null);

const family_name = family_name_field.value;
const family_name_error = family_name_field.errorMessage;

const given_name = given_name_field.value;
const given_name_error = given_name_field.errorMessage;

const family_name_kana = family_name_kana_field.value;
const family_name_kana_error = family_name_kana_field.errorMessage;

const given_name_kana = given_name_kana_field.value;
const given_name_kana_error = given_name_kana_field.errorMessage;

const email = email_field.value;
const email_error = email_field.errorMessage;

const shops = ref<Shop[]>([]);
const selected_shop = ref<Shop | null>(null);
const shop_suggests = ref<Shop[]>([]);
const shop_keyword = ref<string>("");
const shop_error = ref<string | null>(null);

const message = ref<string | null>(null);

const selected_shop_name = computed<string>(() => {
  return selected_shop.value ? selected_shop.value.name : "";
});

onMounted(() => {
  refresh();
});

//   methods: {
const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const salonId = store.state.salon_id as string;
  const id = route.params.staff_id as string | null;
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await Shop.search(salonId);
      shops.value = [];
      shop_suggests.value = [];

      result.shops.forEach(shop => {
        console.log(shop.deleted_at);
        if(shop.deleted_at) {
          return;
        }

        shops.value.push(shop);
        shop_suggests.value.push(shop);
      });

      if (id) {
        staff.value = await Staff.get(id);

        family_name.value = staff.value.family_name;
        given_name.value = staff.value.given_name;
        family_name_kana.value = staff.value.family_name_kana;
        given_name_kana.value = staff.value.given_name_kana;

        shop_keyword.value = staff.value.shop_name;
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const showSuggest = () => {
  showing_suggest.value = true;
};

const onShopnameChanged = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }
  shop_keyword.value = e.target.value;
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  setTimeout(() => {
    try {
      if (!shop_keyword.value) {
        shop_suggests.value = shops.value;
        return;
      }

      const suggests = shops.value.filter(
        (s) => s.name.indexOf(shop_keyword.value) >= 0
      );

      shop_suggests.value = suggests;
      console.log(suggests);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onShopSelected = (shop: Shop) => {
  selected_shop.value = shop;
  shop_keyword.value = shop.name;
  shop_suggests.value.length = 0;

  showing_suggest.value = false;
};

const validate = async (): Promise<boolean> => {
  shop_error.value = null;
  if (!selected_shop.value) {
    shop_error.value = "店舗を選択してください";
  }

  await family_name_field.validate();
  await given_name_field.validate();
  await family_name_kana_field.validate();
  await given_name_kana_field.validate();
  if (!staff.value) {
    await email_field.validate();
  }

  return (
    !family_name_error.value &&
    !given_name_error.value &&
    !family_name_kana_error.value &&
    !given_name_kana_error.value &&
    !email_error.value &&
    !shop_error.value
  );
};

const onSave = () => {
  if (store.state.is_loading) {
    return;
  }

  const salon_id = store.state.salon_id.toString();

  message.value = null;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      if (!selected_shop.value) {
        return;
      }

      if (!staff.value) {
        await Staff.register(
          salon_id,
          selected_shop.value.id,
          family_name.value,
          given_name.value,
          family_name_kana.value,
          given_name_kana.value,
          email.value
        );
      } else {
        await Staff.update(
          staff.value.id,
          selected_shop.value.id,
          family_name.value,
          given_name.value,
          family_name_kana.value,
          given_name_kana.value,
          staff.value.introduce,
          staff.value.main_image_url,
          staff.value.selfy_image_url
        );
      }

      router.push(`/staffs`);
    } catch (ex) {
      message.value = `${ex}`;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(family_name_error) }]),
                placeholder: "苗字",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(family_name) ? (family_name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(family_name)]
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(family_name_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(given_name_error) }]),
                placeholder: "名前",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(given_name) ? (given_name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(given_name)]
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(given_name_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(family_name_kana_error) }]),
                placeholder: "苗字(カナ)",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(family_name_kana) ? (family_name_kana).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(family_name_kana)]
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(family_name_kana_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(given_name_kana_error) }]),
                placeholder: "名前(カナ)",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(given_name_kana) ? (given_name_kana).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(given_name_kana)]
              ]),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(given_name_kana_error)), 1)
            ])
          ])
        ]),
        (!staff.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(email_error) }]),
                    placeholder: "Eメール",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(email)]
                  ]),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(email_error)), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shop_keyword).value = $event)),
                placeholder: "店舗",
                class: "p-3 mb-0.5 w-full border border-gray-300 rounded",
                onInput: onShopnameChanged,
                onFocus: showSuggest
              }, null, 544), [
                [_vModelText, shop_keyword.value]
              ]),
              (showing_suggest.value)
                ? (_openBlock(), _createElementBlock("ul", {
                    key: 0,
                    class: _normalizeClass(["w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-10", { 'border-pink-600': shop_error.value }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shop_suggests.value, (shop) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: shop.name,
                        onClick: ($event: any) => (onShopSelected(shop)),
                        class: "cursor-pointer hover:bg-gray-100 p-1"
                      }, _toDisplayString(shop.name), 9, _hoisted_30))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_31, _toDisplayString(shop_error.value), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_33)
    ]),
    (message.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, _toDisplayString(message.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})